import React, { useState } from 'react'
import NavbarReturnBody from './NavbarReturnBody'
import { t } from 'i18next'
import gearIcon from '../../assets/icons/config-icon-white.svg';
import { ButtonWhite } from '../Buttons/ButtonWhite';
import ScanInputChangeCameraModal from '../Inputs/ScanInput/ScanInputChangeCameraModal';

const NavScanAccess = () => {

    const [showModal, setShowModal] = useState(false);

    return (
        <div>
            <ScanInputChangeCameraModal
                showModal={showModal}
                setShowModal={() => setShowModal(!showModal)}
            />
            <NavbarReturnBody
                title={t('SCAN_QR_OR_ID')}
                returnTo={'/dashboard'}
                iconOrText={
                    <ButtonWhite
                        onClick={() => setShowModal(!showModal)}
                    >
                        <img
                            src={gearIcon}
                            alt=''
                        />
                    </ButtonWhite>
                }
            />
        </div>
    )
}

export default NavScanAccess